import { render, staticRenderFns } from "./EditCaseReasonModal.vue?vue&type=template&id=5a21acfa&"
import script from "./EditCaseReasonModal.vue?vue&type=script&lang=js&"
export * from "./EditCaseReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports